import { useState } from 'react'
import { CustomStore } from '.'
import { filterButtons } from '../utils/helpers/helper'

const CustomStoreProvider = ({ children }: { children: React.ReactNode }) => {
  const [title, setTitle] = useState(filterButtons[3])
  const [search, setSearch] = useState<string>('')
  const [sortBy, setSortBy] = useState<string | number>('')
  const [sortDirection, setSortDirection] = useState<string>('asc')
  const [selectedOption, setSelectedOption] = useState('first')

  const handleOptionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(event.target.value)
  }
  const handleFilter = (filter: { name: string; value: string }) => {
    if (filter.name === 'search') {
      setSearch(filter.value)
    } else {
      setTitle(filter)
    }
  }
  return (
    <CustomStore.Provider
      value={{
        title,
        setFilters: handleFilter,
        handleOptionChange,
        selectedOption,
        search,
        sortBy,
        setSortBy,
        sortDirection,
        setSortDirection,
      }}
    >
      {children}
    </CustomStore.Provider>
  )
}

export default CustomStoreProvider
